import { TextInput, TextInputProps, Text } from '@mantine/core';

/** 9 xonali milliy raqamni "XX XXX XX XX" ko'rinishida formatlaydi. */
export function formatUzNational(input: string): string {
  const d = input.replace(/\D/g, '').replace(/^998/, '').slice(0, 9);
  return [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9)].filter(Boolean).join(' ');
}

/** To'liq raqam: +998XXXXXXXXX (bo'sh bo'lsa ''). */
export function toFullUzPhone(input: string): string {
  const d = input.replace(/\D/g, '').replace(/^998/, '').slice(0, 9);
  return d ? `+998${d}` : '';
}

interface PhoneInputProps extends Omit<TextInputProps, 'value' | 'onChange' | 'leftSection'> {
  value?: string;
  onChange?: (fullPhone: string) => void;
}

/**
 * O'zbek telefon raqami kiritish maydoni.
 * Ko'rsatadi: +998 | 90 123 45 67 ; saqlaydi: +998901234567.
 * Mantine `form.getInputProps('phone')` bilan to'g'ridan-to'g'ri ishlaydi.
 */
export function PhoneInput({ value, onChange, ...props }: PhoneInputProps) {
  return (
    <TextInput
      leftSection={<Text size="sm" c="dimmed" pl={4}>+998</Text>}
      leftSectionWidth={52}
      inputMode="tel"
      placeholder="90 123 45 67"
      value={formatUzNational(value || '')}
      onChange={(e) => onChange?.(toFullUzPhone(e.currentTarget.value))}
      {...props}
    />
  );
}
